import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/views/MyConcern.vue'

Vue.use(Router);
// const originalPush = Router.prototype.push;
// Router.prototype.push = function(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => err);
// };
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/login",
      meta: {
        title: "登录"
      }
    },
    {
      path: "/forgetPassword",
      name: "forget",
      meta: {
        title: "忘记密码"
      },
      component: resolve =>
        require(["../views/components/forgetPassword"], resolve)
    },
    {
      path: "",
      component: resolve => require(["../views/components/home.vue"], resolve),
      children: [
        {
          path: "/shouye",
          name: "首页",
          component: resolve => require(["../views/homepage/index"], resolve)
        },
        {
          path: "/mycoursegoods",
          name: "我发布的课程",
          component: resolve =>
            require(["../views/course/mycoursegoods/index"], resolve)
        },
        {
          path: "/visitadd",
          name: "课程添加",
          component: resolve => require(["../views/visit/index1"], resolve)
        },
        {
          path: "/coursegoodsadd",
          name: "课程添加",
          component: resolve =>
            require(["../views/course/coursegoodsadd/index"], resolve)
        },
        {
          path: "/myknowledge",
          name: "我发布的知识库",
          component: resolve =>
            require(["../views/knowledge/myknowledge"], resolve)
        },
        {
          path: "/knowledgeadd",
          name: "知识库添加",
          component: resolve =>
            require(["../views/knowledge/knowledgeadd"], resolve)
        },
        {
          path: "/knowledgeedit/:id",
          name: "知识库添加",
          component: resolve =>
            require(["../views/knowledge/knowledgeedit"], resolve)
        },
        {
          path: "/coursegoodscompress",
          name: "课程压缩",
          component: resolve =>
            require(["../views/course/coursegoodsadd/compress"], resolve)
        },
        {
          path: "/courseedit/:id",
          component: resolve =>
            require(["../views/course/mycoursegoods/courseedit"], resolve)
        },
        {
          path: "/visitedit/:id",
          component: resolve => require(["../views/visit/courseedit1"], resolve)
        },
        {
          path: "/Section/:id/:ids",
          name: "添加小节",
          component: resolve =>
            require(["../views/course/mycoursegoods/Section"], resolve)
        },
        {
          path: "/editsection/:id/:ids",
          name: "编辑小节",
          component: resolve =>
            require(["../views/course/mycoursegoods/editsection"], resolve)
        },
        {
          path: "/zjgl/:id",
          name: "章节管理",
          component: resolve =>
            require(["../views/course/mycoursegoods/zjglindex"], resolve)
        },
        {
          path: "/bjsptm/:id/:ids",
          name: "章节管理",
          component: resolve =>
            require(["../views/course/mycoursegoods/tjsptm"], resolve)
        },
        {
          path: "/signMeeting",
          component: resolve =>
            require(["../views/meeting/meetingAttendance/index"], resolve)
        },
        {
          path: "/visit",
          component: resolve => require(["../views/visit/index"], resolve)
        },
        {
          path: "/visitdetail",
          component: resolve => require(["../views/visit/detail"], resolve)
        },
        {
          path: "detail/:id",
          component: resolve =>
            require(["../views/meeting/meetingAttendance/detail"], resolve)
        },
        {
          path: "/addmeeting",
          component: resolve =>
            require(["../views/meeting/meetingAttendance/addmeeting"], resolve)
        },
        {
          path: "/editmeeting/:id",
          component: resolve =>
            require(["../views/meeting/meetingAttendance/editmeeting"], resolve)
        },
        {
          path: "/zbjsptm/:id",
          name: "章节管理",
          component: resolve =>
            require(["../views/course/mycoursegoods/ztjsptm"], resolve)
        },
        {
          path: "/pldr",
          name: "批量导入",
          component: resolve =>
            require(["../views/course/mycoursegoods/pldr"], resolve)
        },
        {
          path: "/Courseapproval",
          name: "课程审批管理",
          component: resolve =>
            require(["../views/course/Courseapproval/index"], resolve)
        },
        {
          path: "/stxq/:id",
          name: "试题详情",
          component: resolve =>
            require(["../views/Questionbank/myQuestionbank/stxq"], resolve)
        },
        {
          path: "/tjst",
          name: "试题详情",
          component: resolve =>
            require(["../views/Questionbank/myQuestionbank/tjst"], resolve)
        },
        {
          path: "/editquestionbank/:id",
          name: "编辑试题",
          component: resolve =>
            require([
              "../views/Questionbank/myQuestionbank/editquestionbank"
            ], resolve)
        },
        {
          path: "/Coursesales/:name",
          component: resolve =>
            require(["../views/course/Coursesales/index"], resolve)
        },
        {
          path: "/Coursesaless/:name",
          component: resolve => require(["../views/knowledge/index"], resolve)
        },
        {
          path: "Coursepurchase",
          component: resolve =>
            require(["../views/course/Coursepurchase/index"], resolve)
        },
        {
          path: "/evaluate",
          component: resolve =>
            require(["../views/course/evaluate/index"], resolve)
        },
        {
          path: "/Collection",
          component: resolve =>
            require(["../views/course/Collection/index"], resolve)
        },
        {
          path: "/studentTag",
          component: resolve =>
            require(["../views/fuzhu/studentTag/index"], resolve)
        },
        {
          path: "/askQuestion",
          component: resolve =>
            require(["../views/course/askQuestion/index"], resolve)
        },
        {
          path: "/note",
          component: resolve => require(["../views/course/note/index"], resolve)
        },
        {
          path: "/examinationsyllabus",
          component: resolve =>
            require([
              "../views/Questionbank/examinationsyllabus/index"
            ], resolve)
        },
        {
          path: "/errorCorrection",
          component: resolve =>
            require(["../views/Questionbank/errorCorrection/index"], resolve)
        },
        {
          path: "/addsubject",
          component: resolve =>
            require([
              "../views/Questionbank/examinationsyllabus/addsubject"
            ], resolve)
        },
        {
          path: "/editsubject/:id",
          component: resolve =>
            require([
              "../views/Questionbank/examinationsyllabus/editsubject"
            ], resolve)
        },
        {
          path: "/myQuestionbank",
          component: resolve =>
            require(["../views/Questionbank/myQuestionbank/index"], resolve)
        },

        {
          path: "/myshare",
          component: resolve =>
            require(["../views/Questionbank/myshare/index"], resolve)
        },
        {
          path: "/Sharedquestionbank",
          component: resolve =>
            require(["../views/Questionbank/Sharedquestionbank/index"], resolve)
        },
        {
          path: "/mytestpaper",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/index"], resolve)
        },
        {
          path: "/zdzj",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/zdzj"], resolve)
        },
        {
          path: "/random",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/random"], resolve)
        },
        {
          path: "/editzj/:id",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/editzj"], resolve)
        },
        {
          path: "/editrandom/:id",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/editrandom"], resolve)
        },
        {
          path: "/sdzj",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/sdzj"], resolve)
        },
        {
          path: "/editsdzj/:id",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/editsdzj"], resolve)
        },
        {
          path: "/drsj",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/drsj"], resolve)
        },
        {
          path: "/cksj/:id",
          component: resolve =>
            require(["../views/kaoshi/mytestpaper/cksj"], resolve)
        },
        {
          path: "/studentcksj/:id",
          component: resolve =>
            require(["../views/wuzhihua/examination/studentexam"], resolve)
        },
        {
          path: "/myInvigilator",
          component: resolve =>
            require(["../views/kaoshi/myInvigilator/index"], resolve)
        },
        {
          path: "/ksxq",
          component: resolve =>
            require(["../views/kaoshi/myInvigilator/ksxq"], resolve)
        },
        {
          path: "/Examinationmanagement",
          component: resolve =>
            require(["../views/kaoshi/Examinationmanagement/index"], resolve)
        },
        {
          path: "/Markingmanagement",
          component: resolve =>
            require(["../views/kaoshi/Markingmanagement/index"], resolve)
        },
        {
          path: "/Markingmanagedetails/:id",
          component: resolve =>
            require([
              "../views/kaoshi/Markingmanagement/Markingmanagedetails"
            ], resolve)
        },
        {
          path: "/studentcksjMarkingmanagement/:id/:type",
          component: resolve =>
            require([
              "../views/kaoshi/Markingmanagement/studentcksjMarkingmanagement"
            ], resolve)
        },
        {
          path: "/yj",
          component: resolve =>
            require(["../views/kaoshi/Markingmanagement/yj"], resolve)
        },
        {
          path: "/yjsj",
          component: resolve =>
            require(["../views/kaoshi/Markingmanagement/yjsj"], resolve)
        },
        {
          path: "/sjxqs",
          component: resolve =>
            require(["../views/kaoshi/Markingmanagement/sjxqs"], resolve)
        },
        {
          path: "/craetestudyplan",
          component: resolve =>
            require(["../views/jiaoxue/studyplan/craetestudyplan"], resolve)
        },
        {
          path: "/studymanger/:id",
          component: resolve =>
            require(["../views/jiaoxue/studyplan/studymanger"], resolve)
        },
        {
          path: "/editstudyplan/:id",
          component: resolve =>
            require(["../views/jiaoxue/studyplan/editstudyplan"], resolve)
        },
        {
          path: "/studyplan",
          component: resolve =>
            require(["../views/jiaoxue/studyplan/index"], resolve)
        },
        {
          path: "/craetecoursetype",
          component: resolve =>
            require(["../views/jiaoxue/coursetype/craetecoursetype"], resolve)
        },
        {
          path: "/craetecoursetypes/:id",
          component: resolve =>
            require(["../views/jiaoxue/coursetype/craetecoursetypes"], resolve)
        },
        {
          path: "/editcoursetype/:id",
          component: resolve =>
            require(["../views/jiaoxue/coursetype/editcoursetype"], resolve)
        },
        {
          path: "/coursetype",
          component: resolve =>
            require(["../views/jiaoxue/coursetype/index"], resolve)
        },
        // {
        //   path: "/craetecoursetype",
        //   component: resolve =>
        //     require(["../views/jiaoxue/coursetype/craetecoursetype"], resolve)
        // },
        {
          path: "/craetecolumntype",
          component: resolve =>
            require(["../views/jiaoxue/columntype/craetecolumntype"], resolve)
        },
        {
          path: "/editcolumntype/:id",
          component: resolve =>
            require(["../views/jiaoxue/columntype/editcolumntype"], resolve)
        },
        {
          path: "/columntype",
          component: resolve =>
            require(["../views/jiaoxue/columntype/index"], resolve)
        },
        {
          path: "/design",
          component: resolve =>
            require(["../views/jiaoxue/design/index"], resolve)
        },
        {
          path: "/speaker",
          component: resolve =>
            require(["../views/jiaoxue/speaker/index"], resolve)
        },
        {
          path: "/Markingmanagements",
          component: resolve =>
            require(["../views/jiaoxue/Markingmanagement/index"], resolve)
        },
        {
          path: "/task",
          component: resolve =>
            require(["../views/jiaoxue/task/index"], resolve)
        },
        {
          path: "/notebook/:id",
          component: resolve =>
            require(["../views/jiaoxue/task/notebook"], resolve)
        },
        {
          path: "/notebook/addtest/:id",
          component: resolve =>
            require(["../views/jiaoxue/task/addTest"], resolve)
        },
        {
          path: "/notebook/edittest/:id",
          component: resolve =>
            require(["../views/jiaoxue/task/editTest"], resolve)
        },
        {
          path: "/notebook/testProgress/:id",
          component: resolve =>
            require(["../views/jiaoxue/task/testProgress"], resolve)
        },
        {
          path: "/Questionmanagement",
          component: resolve =>
            require(["../views/jiaoxue/Questionmanagement/index"], resolve)
        },
        {
          path: "/Statistics",
          component: resolve =>
            require(["../views/jiaoxue/Statistics/index"], resolve)
        },
        {
          path: "/certificate",
          component: resolve =>
            require(["../views/jiaoxue/certificate/index"], resolve)
        },
        {
          path: "/zsgl/:id",
          component: resolve =>
            require(["../views/jiaoxue/certificate/zsgl"], resolve)
        },
        {
          path: "/circle",
          component: resolve =>
            require(["../views/fuzhu/circle/index"], resolve)
        },
        {
          path: "/report",
          component: resolve =>
            require(["../views/fuzhu/report/index"], resolve)
        },
        {
          path: "/questionnaireinvestigation",
          component: resolve =>
            require([
              "../views/fuzhu/newquestionnaireinvestigation/index"
            ], resolve)
        },
        {
          path: "/questionnaireinvestigationold",
          component: resolve =>
            require([
              "../views/fuzhu/questionnaireinvestigationnws/index"
            ], resolve)
        },
        {
          path: "/Questionnairedetails/:id",
          component: resolve =>
            require([
              "../views/fuzhu/newquestionnaireinvestigation/Questionnairedetails"
            ], resolve)
        },
        {
          path: "/Questionnairedetailsold/:id",
          component: resolve =>
            require([
              "../views/fuzhu/questionnaireinvestigationnws/Questionnairedetails"
            ], resolve)
        },
        {
          path: "/questionnaireadd",
          component: resolve =>
            require([
              "../views/fuzhu/newquestionnaireinvestigation/questionnaireadd"
            ], resolve)
        },
        {
          path: "/questionnaireaddold",
          component: resolve =>
            require([
              "../views/fuzhu/questionnaireinvestigationnws/questionnaireadd"
            ], resolve)
        },
        {
          path: "/mechanism",
          component: resolve =>
            require(["../views/wuzhihua/mechanism/index"], resolve)
        },
        {
          path: "/editquestionnaire/:id",
          component: resolve =>
            require([
              "../views/fuzhu/newquestionnaireinvestigation/editquestionnaire"
            ], resolve)
        },
        {
          path: "/editquestionnaireold/:id",
          component: resolve =>
            require([
              "../views/fuzhu/questionnaireinvestigationnws/editquestionnaire"
            ], resolve)
        },
        {
          path: "/students",
          component: resolve =>
            require(["../views/fuzhu/students/index"], resolve)
        },
        {
          path: "/creat",
          component: resolve =>
            require(["../views/wuzhihua/creat/index"], resolve)
        },

        {
          path: "/examination",
          component: resolve =>
            require(["../views/wuzhihua/examination/index"], resolve)
        },

        {
          path: "/Examidetails/:id",
          component: resolve =>
            require(["../views/wuzhihua/examination/Examidetails"], resolve)
        },

        {
          path: "/editexam/:id",
          component: resolve =>
            require(["../views/wuzhihua/examination/editeaxam"], resolve)
        },
        {
          path: "/quickexam/:id",
          component: resolve =>
            require(["../views/wuzhihua/examination/quickexam"], resolve)
        },
        {
          path: "/copyexam/:id",
          component: resolve =>
            require(["../views/wuzhihua/examination/copyexam"], resolve)
        },
        {
          path: "/Examinationreport",
          component: resolve =>
            require(["../views/baobiao/Examinationreport/index"], resolve)
        },
        {
          path: "/testreport",
          component: resolve =>
            require(["../views/baobiao/testreport/index"], resolve)
        },
        {
          path: "/coursereport",
          component: resolve =>
            require(["../views/baobiao/coursereport/index"], resolve)
        },
        {
          path: "/Questionbankreport",
          component: resolve =>
            require(["../views/baobiao/Questionbankreport/index"], resolve)
        },
        {
          path: "/organization",
          component: resolve => require(["../views/User/organization"], resolve)
        },
        {
          path: "/slideshow",
          component: resolve => require(["../views/slideshow/index"], resolve)
        },
        {
          path: "/userquery",
          component: resolve => require(["../views/User/index"], resolve)
        },
        {
          path: "/role",
          component: resolve => require(["../views/role/index"], resolve)
        },
        {
          path: "/LoginLog",
          component: resolve => require(["../views/loginLog/index"], resolve)
        },
        {
          path: "/alarm",
          component: resolve =>
            require(["../views/faultComponents/alarmQuery"], resolve)
        },
        {
          path: "/notify",
          component: resolve =>
            require(["../views/faultComponents/notifyQuery"], resolve)
        },
        {
          path: "/faultHandling",
          component: resolve =>
            require(["../views/faultComponents/faultHandling"], resolve)
        },
        {
          path: "/message",
          component: resolve => require(["../views/message/message"], resolve)
        }
      ]
    },
    {
      path: "/login",
      component: resolve => require(["../views/components/login.vue"], resolve),
      meta: {
        title: "登录"
      }
    }
  ]
});

// Router.beforeEach((to, from, next) => {
//   if (to.path === "/login") return next();
//   const tokenStr = sessionStorage.getItem("userName");
//   if (!tokenStr) return next("/login");
//   next();
// });
// vueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };
Vue.use(Router);



// WEBPACK FOOTER //
// ./src/router/index.js